import React, { useState, useEffect } from "react";
import cx from "classnames";
import styles from "../scss/AppFormField.module.scss";

interface IAFSingleTextProps {
    question: any;
}

const AFSingleText: React.FC<IAFSingleTextProps> = (props) => {
    const { question } = props;

    return (
        <div className={styles["af-single-field"]} id={question.id}>
                <div className={cx([styles["input-field"]])}></div>
        </div>
    );
};

export default AFSingleText;
